import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { SelectedPost, SwitchPostVO } from '../../models/switchPost.model';
import { Response } from '../../models/response.model';
import { AuthenticationService } from '../../services/authentication.service';
import { AppInitService } from '../../services/app-init.service';

@Injectable({
  providedIn: 'root',
})
export class SwitchPostService {
  public currentUserSwitchPost: SwitchPostVO = null;
  public useGeoLocBasedPostSelection: boolean = false;
  constructor(
    private http: HttpClient,
    private authService: AuthenticationService,
    private appInitService: AppInitService
  ) {
    //this.useGeoLocBasedPostSelection = this.appInitService.appConfig?.configurableFields?.useGeoLocBasedPostSelection;
    this.appInitService.getConfigurableFields().subscribe(() => {
      this.useGeoLocBasedPostSelection = this.appInitService.appConfig?.configurableFields?.useGeoLocBasedPostSelection;
    });
  }

  getSwitchPostDtls(): Observable<SwitchPostVO> {
    return this.http.get<Response<SwitchPostVO>>('/core/switch-post').pipe(
      map((res) => res.data),
      tap((switchDtls) => {
        this.currentUserSwitchPost = switchDtls;
        this.authService.loggedInUserPost = this.getCurrentPostByDtls(
          switchDtls
        );
      })
    );
  }
  getCurrentPostByDtls(switchDtls: SwitchPostVO): SelectedPost {
    if (
      typeof switchDtls?.postDetailsVO === 'object' &&
      switchDtls?.postDetailsVO
    ) {
      return switchDtls?.postDetailsVO;
    }
    if (
      (switchDtls?.postDetailsVO?.toString().toLowerCase() === 'default' &&
        switchDtls?.defaultPostId === -1) ||
      switchDtls?.postDetailsVO?.toString().toLowerCase() === 'all selected'
    ) {
      const postData = {
        DSGN_ID: switchDtls?.allPost?.[0]?.desgId,
        ORG_ID: switchDtls?.allPost?.[0]?.orgId,
        POST_ID: switchDtls?.allPost?.[0]?.postId,
        UNIT_ID: switchDtls?.allPost?.[0]?.unitId,
      };
      return postData;
    }
    if (switchDtls?.defaultPostId > -1) {
      const postIndex = switchDtls.allPost.findIndex(
        (p) => p.postId === switchDtls.defaultPostId
      );
      const postData = {
        DSGN_ID: switchDtls?.allPost?.[postIndex]?.desgId,
        ORG_ID: switchDtls?.allPost?.[postIndex]?.orgId,
        POST_ID: switchDtls?.allPost?.[postIndex]?.postId,
        UNIT_ID: switchDtls?.allPost?.[postIndex]?.unitId,
      };
      return postData;
    }
    return null;
  }

  selectPosts(body) {
    return this.http.post('/core/switch-post/selected-post-id', body);
  }

  selectDefaultPost(id) {
    return this.http.put('/core/switch-post/default-postid/' + id, null);
  }
  setLoginDisp(status) {
    return this.http.put('/core/switch-post/switchpost-enable/' + status, null);
  }

  getGeoLocDtlsForLoggedInUser(): Observable<any> {
    return this.http.get('/common/getGeoLocDtls');
  }
}
